enum EnvTypes {
  STAGE = 'stage',
  PROD = 'prod',
  PRERELEASE = 'prerelease',
  LOCAL = 'local',
}

export default EnvTypes;
